import FooterComponent from "../components/FooterComponent"
import HeaderComponent from "../components/HeaderComponent"
import VideoDemoGalleryComponent from "../components/VideoGalleryComponent"

const DemoPage = () => {
    return(
        <>
            <HeaderComponent/>
            <div className="bg-gray-100">
            <VideoDemoGalleryComponent/>
            </div>
            <FooterComponent/>
        </>
    )
}

export default DemoPage